import { formatDuration, intervalToDuration } from "date-fns";
export function getJobDuration(job) {
    return formatDuration(intervalToDuration({ start: new Date(job.create_time), end: new Date(job.update_time) }));
}
